import { Component, OnInit } from '@angular/core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { RefreshComponent } from 'src/app/core/grid-renderer/refresh/refresh.component';
import { ResolutionOrdersService } from 'src/app/services/resolution-orders.service';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { ResolutionsService } from 'src/app/services/resolutions.service';
import { EventService } from 'src/app/services/event.service';
import { FilterChangedEvent, GridOptions } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'app-resolution-orders',
    templateUrl: './resolution-orders.component.html',
    styleUrls: ['./resolution-orders.component.scss'],
    standalone: false // NOSONAR
})
export class ResolutionOrdersComponent implements OnInit {

  faChevronRight = faChevronRight;

  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: number = 10;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  historyRowData: any;
  shouldHide: any = true
  gridOptions: any;
  eventId: string;
  errorMessage: any;
  resolutionId:any;
  successMessage: any;
  caCodeArr: any;
  constructor(  private readonly dialog : MatDialog, 
    private  readonly constants: Constants, 
    private readonly resolutionsService: ResolutionsService, 
    private readonly resolutionOrdersService: ResolutionOrdersService, 
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
     private readonly eventService : EventService) {

    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      filter: true,
      floatingFilter: true
    }
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">'
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0', // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }

  ngOnInit(): void {
    this.successMessage=null;
    this.errorMessage=null;
    this.resolutionId ='';
    this.historyRowData = JSON.parse(sessionStorage.getItem('history-details'))
    this.ngxUiLoaderService.start(CommonConstant.loader);
     this.caCodeCall()
    if(localStorage.getItem('resolutionId')) {
      this.resolutionId = localStorage.getItem('resolutionId');
    }
    this.resolutionOrdersService.getCountOrders(this.resolutionId).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        if (res.ordersSize > 0) {
          this.apiCall();
        }
        else
          {this.displayRowData = [];}
          
      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    })
 
     
  }

  getColumns() {
    this.columnDefs = [
      {
        floatingFilterComponent: RefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 30,
        maxWidth: 40,
      },
      {
        headerName: 'UNLOAD',
        field: 'arrival',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'ROUTE',
        field: 'route',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'REGION',
        field: 'region',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'SUPPLIER',
        field: 'supplierId',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'CA CODE',
        field: 'caCode',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
        valueGetter: this.MapCaCode.bind(this),
      },
      {
        headerName: 'PLANT',
        field: 'plantId',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'DOCK',
        field: 'logicalDockId',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'ORDER NUMBER',
        field: 'orderNumber',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 130,
        maxWidth: 140,
      },
      {
        headerName: 'NEXT ROUTE',
        field: 'nextRoute',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 130,
        maxWidth: 140,
      },
      {
        headerName: 'NEXT CONNECTION',
        field: 'reloadStart',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'ROUTE 1',
        field: 'route1',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'REGION 1',
        field: 'route1Region',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 110,
      },
      {
        headerName: 'CD1 U/L',
        field: 'route1Unload',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'ROUTE 2',
        field: 'route2',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'REGION 2',
        field: 'route2Region',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'CD1 R/L',
        field: 'route1Reload',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'CD2 U/L',
        field: 'route2Unload',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'ROUTE 3',
        field: 'route3',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'REGION 3',
        field: 'route3Region',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'CD2 R/L',
        field: 'route2Reload',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'CD3 U/L',
        field: 'route3Unload',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'ROUTE 4',
        field: 'route4',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'REGION 4',
        field: 'route4Region',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 90,
        maxWidth: 100,
      },
      {
        headerName: 'CD3 R/L',
        field: 'route3Reload',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
      {
        headerName: 'CD4 U/L',
        field: 'route4Unload',
        floatingFilter: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
        minWidth: 150,
        maxWidth: 160,
        comparator: this.dateComparator,
      },
    ];
  }

  caCodeCall() {
    

    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.resolutionOrdersService.getAllCanadaCode().subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.caCodeArr = res;
         
        this.getColumns();
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        console.info(error);
      },
    });
  }

  MapCaCode (params: any) {
     return this.caCodeArr[params.data.supplierId]
  }
  apiCall() {
    this.errorMessage = null;
    this.successMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.resolutionOrdersService.getResolutionOrders(this.resolutionId).subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.displayRowData = res.map((element:any)=>{
          return {
            ...element,
            arrival:this.dateFormatter(element.arrival),
            reloadStart:this.dateFormatter(element.reloadStart),
            route1Unload:this.dateFormatter(element.route1Unload),
            route1Reload:this.dateFormatter(element.route1Reload),
            route2Unload:this.dateFormatter(element.route2Unload),
            route2Reload:this.dateFormatter(element.route2Reload),
            route3Unload:this.dateFormatter(element.route3Unload),
            route3Reload:this.dateFormatter(element.route3Reload),
            route4Unload:this.dateFormatter(element.route4Unload),
          }
        });
        this.rowCount = this.displayRowData.length;
      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
      }
    })
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }
  dateFormatter(res) {

    if (res == null) {return '';} // NOSONAR

    else {return moment(res).format('MM/DD/YYYY HH:mm');}

  }
  reOpenHistory() {
    this.shouldHide = true;
  }
  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if(this.rowCount == 0 && Number(check) == 0 ){ // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML='0';
    }
    }
  sizeToFit() { this.gridApi?.sizeColumnsToFit() };

  onGridReady(params: any) {
    this.gridApi = params.api;

    this.gridApi.applyTransaction({ add: this.displayRowData }); 
    this.rowCount = this.displayRowData.length;
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage() }
  goToPreviousPage() { return this.gridApi.paginationGoToPreviousPage() }
  goToFirstPage() { this.gridApi.paginationGoToFirstPage() }
  goToLastPage() { return this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false;
      
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText('#lbCurrentPage', this.gridApi.paginationGetCurrentPage() + 1);
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") { // NOSONAR
      this.paginationPageSize = event.target.value;
      
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }
}
function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}
